import { Redirect, useLocation } from "react-router-dom";
import { getAuthErrorDescription } from "selectors/user";
import { getEnvVars } from "selectors/envVars";
import { useSelector } from "react-redux";
import React from "react";
import UiRoutes from "const/UiRoutes";
import Urls from "utils/Urls";

const getReturnTo = ({ pathname, search, envVars, userAuthError }) => {
  if (userAuthError) return null;
  if (pathname === UiRoutes.MAIN && !search) return null;

  const {
    code,
    state,
    error,
    error_description: errorDescription,
    ...returnToEnvVars
  } = envVars;

  if (code || state || error || errorDescription) {
    const query = Urls.objectToQueryString(returnToEnvVars);

    return btoa(`${pathname}${query ? `?${query}` : ""}`);
  }

  return btoa(pathname + search);
};

const LoginRedirect = () => {
  const { search, pathname } = useLocation();

  const envVars = useSelector(getEnvVars);

  const userAuthError = useSelector(getAuthErrorDescription);

  const query = userAuthError
    ? Urls.objectToQueryString(envVars)
    : Urls.objectToQueryString({ returnTo: getReturnTo({ pathname, search, envVars, userAuthError }) });

  const redirectUrl = `${UiRoutes.LOGIN}${query ? `?${query}` : ""}`;

  return <Redirect to={redirectUrl} />;
};

export default React.memo(LoginRedirect);
